import React, { useState } from 'react';
import Swal from 'sweetalert2';

const Services = () => {
  const [isPurchaseModalOpen, setIsPurchaseModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState(null);

  const openPurchaseModal = (service) => {
    setSelectedService(service);
    setIsPurchaseModalOpen(true);
  };

  const closePurchaseModal = () => {
    setIsPurchaseModalOpen(false);
    setSelectedService(null);
  };

  const services = [
    {
      title: "How to Devise a Winning Campaign Strategy",
      description: "Master the fundamentals of creating a winning campaign strategy that adapts to Kenya's unique political landscape and voter dynamics.",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=300&fit=crop",
      features: ["Strategic Planning", "Campaign Design", "Risk Assessment", "Victory Roadmap"]
    },
    {
      title: "How to Organise Your Campaign",
      description: "Learn the essential skills for organizing your campaign effectively for maximum impact and operational efficiency.",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=300&fit=crop",
      features: ["Team Structure", "Resource Management", "Timeline Planning", "Operations Excellence"]
    },
    {
      title: "How to Create Effective Campaign Advertising",
      description: "Discover how to create powerful and persuasive campaign advertising that resonates with Kenyan voters and drives engagement.",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=300&fit=crop",
      features: ["Message Development", "Creative Strategy", "Media Planning", "Brand Positioning"]
    },
    {
      title: "How to Use Domestic Policy to Electoral Advantage",
      description: "Learn strategic techniques to leverage domestic policy issues for electoral success and effective voter mobilization.",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=300&fit=crop",
      features: ["Policy Analysis", "Issue Framing", "Voter Priorities", "Position Development"]
    },
    {
      title: "How to Use Foreign Policy to Electoral Advantage",
      description: "Master the strategic use of foreign policy to enhance your electoral positioning and build credibility with voters.",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=300&fit=crop",
      features: ["International Relations", "Diplomatic Strategy", "Global Positioning", "Policy Communication"]
    },
    {
      title: "How to Use Opinion Polls and Focus Groups",
      description: "Strategic application of opinion polls and focus groups to guide campaign decisions and optimize messaging strategies.",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=300&fit=crop",
      features: ["Poll Analysis", "Focus Group Design", "Data Interpretation", "Strategic Insights"]
    },
    {
      title: "How to Perform Well in Media Interviews",
      description: "Develop the skills to perform confidently and effectively in media interviews with professional training and preparation.",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=300&fit=crop",
      features: ["Interview Techniques", "Crisis Management", "Message Delivery", "Media Strategy"]
    },
    {
      title: "How to Give Effective Speeches",
      description: "Learn to deliver impactful and memorable speeches that inspire voters and build electoral momentum.",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=300&fit=crop",
      features: ["Speech Writing", "Delivery Techniques", "Audience Engagement", "Rhetorical Skills"]
    },
    {
      title: "How to Survive Your Opponent's Attacks",
      description: "Master techniques to survive and counter your opponent's attacks while maintaining voter trust and campaign momentum.",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=300&fit=crop",
      features: ["Attack Preparation", "Response Strategy", "Crisis Communication", "Damage Control"]
    },
    {
      title: "How to Identify Your Voters and Get them to the Polls",
      description: "Strategic voter identification and mobilization techniques to ensure maximum turnout on election day.",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=300&fit=crop",
      features: ["Voter Targeting", "Mobilization Strategy", "GOTV Tactics", "Election Day Operations"]
    }
  ];

  return (
    <div>
      {/* Enhanced Services Overview */}
      <section className="bg-secondary-50 pt-8 pb-12 sm:pb-16 lg:pb-20 px-4 sm:px-6 lg:px-8 relative">
        <div className="absolute inset-0 bg-pattern opacity-5"></div>
        <div className="relative container-max">
          <div className="text-center mb-6 sm:mb-8 lg:mb-10">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-6xl font-bold text-secondary-900 mb-4 sm:mb-6">
              Comprehensive Campaign Services
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-secondary-600 max-w-4xl mx-auto leading-relaxed px-4">
              From strategic planning to execution, we provide end-to-end support for political campaigns
              that understand Kenya's diverse electorate, regional dynamics, and modern campaigning techniques.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-4 lg:gap-6 mb-12 sm:mb-16">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white p-3 sm:p-4 lg:p-5 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 group animate-fade-in flex flex-col h-full cursor-pointer"
                style={{animationDelay: `${index * 0.1}s`}}
                onClick={() => openPurchaseModal(service)}
              >
                <div className="flex-grow">
                  <div className="mb-2 sm:mb-3 lg:mb-4 overflow-hidden rounded-md">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-24 sm:h-28 lg:h-32 object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  <h3 className="text-sm sm:text-base lg:text-lg font-bold text-secondary-900 mb-1 sm:mb-2 group-hover:text-primary-600 transition-colors duration-300">
                    {service.title}
                  </h3>
                  <p className="text-secondary-600 leading-relaxed mb-2 sm:mb-3 text-xs sm:text-sm">{service.description}</p>
                  <div className="space-y-1">
                    {service.features.slice(0, 2).map((feature, featureIndex) => (
                      <div key={featureIndex} className="flex items-center text-xs text-secondary-500">
                        <span className="text-primary-600 mr-1">✓</span>
                        {feature}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="mt-auto">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      openPurchaseModal(service);
                    }}
                    className="w-full bg-primary-600 text-white px-3 py-2 rounded-lg font-semibold hover:bg-primary-700 transition-colors duration-200 text-xs sm:text-sm"
                  >
                    Purchase Now - $5000
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center space-y-4 sm:space-y-6">
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center px-4">
              <a href="#contact" className="btn-primary transform hover:scale-105 transition-transform duration-200 text-sm sm:text-base py-2.5 sm:py-3 px-4 sm:px-6">
                Get Started Today
              </a>
              <a href="#about" className="btn-secondary transform hover:scale-105 transition-transform duration-200 text-sm sm:text-base py-2.5 sm:py-3 px-4 sm:px-6">
                Learn More About KISS
              </a>
            </div>
            <p className="text-secondary-500 text-sm sm:text-base lg:text-lg px-4">
              Trusted by political leaders across all 47 counties
            </p>
          </div>
        </div>
      </section>

      {/* Purchase Modal */}
      <div className={`fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4 ${isPurchaseModalOpen ? '' : 'hidden'}`}>
        <div
          className="absolute inset-0 bg-black bg-opacity-60 backdrop-blur-sm"
          onClick={closePurchaseModal}
        ></div>

        <div className="relative w-full max-w-4xl bg-white rounded-2xl shadow-2xl overflow-hidden animate-fade-in max-h-[95vh]">
          <button
            onClick={closePurchaseModal}
            className="absolute top-3 right-3 text-secondary-500 hover:text-secondary-800 bg-white/90 hover:bg-white rounded-full p-2 shadow-sm transition-colors duration-200 z-20"
            aria-label="Close purchase modal"
          >
            <i className="bi bi-x-lg text-lg"></i>
          </button>

          <div className="grid grid-cols-1 lg:grid-cols-2 max-h-full overflow-hidden">
            {/* Left panel - Service details */}
            <div className="bg-gradient-to-b from-primary-50 to-primary-100 p-6 sm:p-8 flex flex-col gap-6">
              <div>
                <h2 className="text-2xl sm:text-3xl font-bold text-secondary-900 leading-tight mb-4">
                  {selectedService?.title}
                </h2>
                <p className="text-secondary-600 leading-relaxed text-sm sm:text-base">
                  {selectedService?.description}
                </p>
              </div>

              <div className="bg-white rounded-lg p-4 shadow-sm">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-lg font-semibold text-secondary-900">Total Cost:</span>
                  <span className="text-3xl font-bold text-primary-600">$5,000 USD</span>
                </div>
                <p className="text-xs text-secondary-500">One-time payment • Lifetime access</p>
              </div>

              <div>
                <h3 className="font-semibold text-secondary-900 mb-3">What you'll get:</h3>
                <ul className="space-y-2">
                  {selectedService?.features.map((feature, index) => (
                    <li key={index} className="flex items-center text-sm text-secondary-600">
                      <span className="text-primary-600 mr-2">✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="bg-primary-50 rounded-lg p-4">
                <div className="flex items-center space-x-2 text-primary-700">
                  <i className="bi bi-shield-check text-lg"></i>
                  <span className="font-semibold text-sm">Secure Payment Processing</span>
                </div>
                <p className="text-xs text-primary-600 mt-1">256-bit SSL encryption • PCI compliant</p>
              </div>
            </div>

            {/* Right panel - Payment form */}
            <div className="bg-secondary-50 p-6 sm:p-8">
              <div className="mb-6">
                <h3 className="text-xl font-bold text-secondary-900 mb-2">Complete Your Purchase</h3>
                <p className="text-secondary-600 text-sm">Fill in your details to access this premium strategy guide.</p>
              </div>

              <form onSubmit={(e) => {
                e.preventDefault();
                // Simulate payment processing
                Swal.fire({
                  icon: 'success',
                  title: 'Purchase Successful!',
                  text: `Thank you for your purchase! You will receive access to "${selectedService?.title}" within 24 hours. A confirmation email has been sent.`,
                  confirmButtonColor: '#2563eb'
                });
                closePurchaseModal();
              }} className="space-y-4">
                <div className="relative">
                  <i className="bi bi-person text-secondary-400 absolute left-3 top-1/2 -translate-y-1/2"></i>
                  <input
                    type="text"
                    name="name"
                    placeholder="Full Name*"
                    required
                    className="w-full pl-10 pr-4 py-3 rounded-lg bg-white border border-secondary-200 focus:ring-2 focus:ring-primary-500 focus:border-primary-500 text-secondary-900 placeholder-secondary-400"
                  />
                </div>

                <div className="relative">
                  <i className="bi bi-envelope text-secondary-400 absolute left-3 top-1/2 -translate-y-1/2"></i>
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address*"
                    required
                    className="w-full pl-10 pr-4 py-3 rounded-lg bg-white border border-secondary-200 focus:ring-2 focus:ring-primary-500 focus:border-primary-500 text-secondary-900 placeholder-secondary-400"
                  />
                </div>

                <div className="relative">
                  <i className="bi bi-telephone text-secondary-400 absolute left-3 top-1/2 -translate-y-1/2"></i>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone Number*"
                    required
                    className="w-full pl-10 pr-4 py-3 rounded-lg bg-white border border-secondary-200 focus:ring-2 focus:ring-primary-500 focus:border-primary-500 text-secondary-900 placeholder-secondary-400"
                  />
                </div>

                <div className="relative">
                  <i className="bi bi-geo-alt text-secondary-400 absolute left-3 top-1/2 -translate-y-1/2"></i>
                  <input
                    type="text"
                    name="county"
                    placeholder="County/Constituency*"
                    required
                    className="w-full pl-10 pr-4 py-3 rounded-lg bg-white border border-secondary-200 focus:ring-2 focus:ring-primary-500 focus:border-primary-500 text-secondary-900 placeholder-secondary-400"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-secondary-700 mb-2">Payment Method</label>
                  <div className="space-y-2">
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="paymentMethod"
                        value="card"
                        defaultChecked
                        className="text-primary-600 focus:ring-primary-500"
                      />
                      <span className="ml-2 text-sm text-secondary-700">Credit/Debit Card</span>
                    </label>
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="paymentMethod"
                        value="paypal"
                        className="text-primary-600 focus:ring-primary-500"
                      />
                      <span className="ml-2 text-sm text-secondary-700">PayPal</span>
                    </label>
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="paymentMethod"
                        value="bank"
                        className="text-primary-600 focus:ring-primary-500"
                      />
                      <span className="ml-2 text-sm text-secondary-700">Bank Transfer</span>
                    </label>
                  </div>
                </div>

                <button
                  type="submit"
                  className="w-full bg-primary-600 hover:bg-primary-700 text-white font-semibold py-3 rounded-lg shadow-lg transition-all duration-200 flex items-center justify-center"
                >
                  <i className="bi bi-credit-card mr-2"></i>
                  Pay $5,000 USD & Get Access
                </button>

                <p className="text-xs text-center text-secondary-500">
                  Secure payment • Instant access • 30-day money-back guarantee
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;